// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimDetails-cls1_DKj","cls2":"ClaimDetails-cls2_s_1 ClaimDetails-cls1_DKj"};